import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { BulletList } from 'src/components/bullet-points';
import { OrderedList } from 'src/components/ordered-list';
import { link } from 'src/styles/mixins';
import { spacing1, spacing2, spacing3 } from 'src/styles/spacing';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

export const StyledTypography = styled(Typography)`
  color: inherit;
`;

export const StyledHeaderPrimary = styled(StyledTypography)`
  margin-top: ${spacing3};
  margin-bottom: ${spacing3};
`;

export const StyledHeaderSecondary = styled(StyledTypography)`
  margin-top: ${spacing3};
  margin-bottom: ${spacing3};
`;

export const StyledHeaderTertiary = styled(StyledTypography)`
  margin-top: ${spacing3};
  margin-bottom: ${spacing2};
`;

export const StyledSubtitlePrimary = styled(StyledTypography)`
  margin-top: ${spacing3};
  margin-bottom: ${spacing2};
`;

export const StyledSubtitleSecondary = styled(StyledTypography)`
  margin-top: ${spacing3};
  margin-bottom: ${spacing2};
`;

export const StyledSubtitleTertiary = styled(StyledTypography)`
  margin-top: ${spacing3};
  margin-bottom: ${spacing2};
  font-weight: bold;
`;

export const StyledNormalText = styled(StyledTypography)`
  margin-top: ${spacing1};
  margin-bottom: ${spacing1};
`;

export const StyledBulletList = styled(BulletList)`
  margin-top: ${spacing1};
  margin-bottom: ${spacing1};
`;

export const StyledLink = styled.a`
  ${link};
`;

export const StyledOrderedList = styled(OrderedList)`
  margin-top: ${spacing1};
  margin-bottom: ${spacing1};
`;
